import { render } from "./MemoContent.vue?vue&type=template&id=b091d854"
import script from "./MemoContent.vue?vue&type=script&lang=js"
export * from "./MemoContent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__